<h2 mat-dialog-title class="mb-3">SEO Action Details</h2>
<mat-dialog-content class="modal-content-scroll">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 detail-section">
        <span class="detail-label">URL</span>
        <div class="detail-value">{{ data.item.url }}</div>
      </div>
      
      <div class="col-md-6 detail-section">
        <span class="detail-label">Issue Type</span>
        <div class="detail-value">{{ data.item.issueType }}</div>
      </div>
      
      <div class="col-md-6 detail-section">
        <span class="detail-label">Priority</span>
        <div class="detail-value">{{ data.item.priority }}</div>
      </div>

      <div class="col-12 detail-section">
        <hr>
      </div>

      <div class="col-12 detail-section" *ngIf="data.item.diagnosis">
        <span class="detail-label">Diagnosis</span>
        <div class="detail-value">{{ data.item.diagnosis }}</div>
      </div>

      <div class="col-12 detail-section" *ngIf="data.item.recommendation">
        <span class="detail-label">Recommendation</span>
        <div class="detail-value">{{ data.item.recommendation }}</div>
      </div>

      <div class="col-12 detail-section" *ngIf="data.item.proposed_changes">
        <span class="detail-label">Proposed Changes</span>
        <div class="detail-value">{{ data.item.proposed_changes }}</div>
      </div>

      <div class="col-12 detail-section" *ngIf="data.item.notes">
        <span class="detail-label">Notes</span>
        <div class="detail-value">{{ data.item.notes }}</div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="mt-3">
  <button class="btn btn-dark btn-sm" (click)="close()">Close</button>
</mat-dialog-actions>
